
import { Base } from '../base-component';

import './page-intro.component.scss';

export class PageIntro extends Base {

	constructor(element: Element){

		super(element)
				
	}

	init(){}
		
	bindEvents(){}

}




// WEBPACK FOOTER //
// ./components/page-intro/page-intro.component.ts